// extracted by mini-css-extract-plugin
export default {"loader":"style_loader__7o2Eh","loaderinner":"style_loaderinner__yZ4+Y"};